/**
 *
 * FormEmailRecipientTypes(multi) AsyncPicker
 *
 */

import { Entity } from 'types/common';
import { FieldHookConfig, useField } from 'formik';
import { IFieldProps } from './FormRender/IFormFieldSetting';
import { EmailRecipientTypesPicker } from '../pickers/MultiSelectPickers/EmailRecipientTypesPicker';

export const FormEmailRecipientTypesPicker = ({
  label,
  ...props
}: FieldHookConfig<Entity<number>[] | null> & IFieldProps) => {
  const [field, meta, helpers] = useField<Entity<number>[] | null>(props);
  return (
    <>
      <EmailRecipientTypesPicker
        name={props.name}
        placeholder={props.placeholder}
        label={label}
        onChange={value => {
          helpers.setValue(value, true);
          if (props.onChange) {
            props.onChange(value);
          }
        }}
        onBlur={field?.onBlur}
        value={field.value}
        variant="filled"
        error={meta?.error !== undefined}
        helperText={meta.error}
        fullWidth={props.fullWidth}
        info={props.info}
      />
    </>
  );
};
